<template>
  <div>
    <el-tabs v-model="activateName">
      <el-tab-pane label="产线表" name="first">
        <div class="searchBox">
          <el-form :inline="true" :model="filter">
            <el-form-item label="计划日期">
              <el-date-picker
                  v-model="filter.date"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择计划日期"/>
            </el-form-item>
          </el-form>
          <el-button style="height: 29px" :loading="searchLoading" type="primary" @click="loadData()">查询</el-button>
          <el-button style="height: 29px" type="primary" plain @click="resetHandle">重置</el-button>
        </div>
        <Table
            :data="tableData"
            :columns="columns"
            module="basic"
            stripe
            border>
          <template slot="percent" slot-scope="{ row }">
            <Progress :percent="parseFloat((row.percent * 100).toFixed(2))" :stroke-width="20"/>
          </template>
        </Table>
      </el-tab-pane>
      <el-tab-pane label="计划排产" name="second">
        <div class="searchBox">
          <el-form :inline="true" :model="filter2">
            <el-form-item label="计划日期">
              <el-date-picker
                  v-model="planDate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  @change="selectPlanDate"/>
            </el-form-item>
          </el-form>
          <el-button style="height: 29px" :loading="searchLoading2" type="primary" @click="loadData2()">查询</el-button>
          <el-button style="height: 29px" type="primary" plain @click="resetHandle2">重置</el-button>
        </div>
        <Table
            :data="tableData2"
            :columns="columns2"
            module="basic"
            stripe
            border>
          <template slot="percent" slot-scope="{ row }">
            <Progress :percent="parseFloat((row.percent * 100).toFixed(2))" :stroke-width="20"/>
          </template>
        </Table>
      </el-tab-pane>
      <el-tab-pane label="员工计划" name="three">
        <div class="searchBox">
          <el-form :inline="true" :model="filter3">
            <el-form-item label="计划日期">
              <el-date-picker
                  v-model="planDate3"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  @change="selectPlanDate3"/>
            </el-form-item>
          </el-form>
          <el-button style="height: 29px" :loading="searchLoading3" type="primary" @click="loadData3()">查询</el-button>
          <el-button style="height: 29px" type="primary" plain @click="resetHandle3">重置</el-button>
        </div>
        <Table
            :data="tableData3"
            :columns="columns3"
            module="basic"
            stripe
            border>
          <template slot="percent" slot-scope="{ row }">
            <Progress :percent="parseFloat((row.percent * 100).toFixed(2))" :stroke-width="20"/>
          </template>
        </Table>
      </el-tab-pane>
      <!--      <el-tab-pane label="工位计划" name="four" hidden>-->
      <!--        <div class="searchBox">-->
      <!--          <el-form :inline="true" :model="filter">-->
      <!--            <el-form-item label="计划日期">-->
      <!--              <el-date-picker-->
      <!--                  v-model="filter.date"-->
      <!--                  type="date"-->
      <!--                  value-format="yyyy-MM-dd"-->
      <!--                  placeholder="请选择计划日期"/>-->
      <!--            </el-form-item>-->
      <!--          </el-form>-->
      <!--          <el-button style="height: 29px" :loading="searchLoading" type="primary" @click="loadData4()">查询</el-button>-->
      <!--          <el-button style="height: 29px" type="primary" plain @click="resetHandle">重置</el-button>-->
      <!--        </div>-->
      <!--        <el-divider/>-->
      <!--        <div style="margin-top: 10px;">-->
      <!--          <el-form-->
      <!--              :model="sumData"-->
      <!--              class="form"-->
      <!--              label-width="80px">-->
      <!--            <el-row>-->
      <!--              <el-col :span="6">-->
      <!--                <el-form-item label="产品数量" prop="sumQuantity" disabled>-->
      <!--                  <el-input v-model="sumData.sumQuantity" readonly/>-->
      <!--                </el-form-item>-->
      <!--              </el-col>-->
      <!--              <el-col :span="6">-->
      <!--                <el-form-item label="标准工时" prop="sumStandardTime" disabled>-->
      <!--                  <el-input v-model="sumData.sumStandardTime" readonly/>-->
      <!--                </el-form-item>-->
      <!--              </el-col>-->
      <!--            </el-row>-->
      <!--            <el-row>-->
      <!--              <el-col :span="6">-->
      <!--                <el-form-item label="出勤工时" prop="sumWorkTime" disabled>-->
      <!--                  <el-input v-model="sumData.sumWorkTime" readonly/>-->
      <!--                </el-form-item>-->
      <!--              </el-col>-->
      <!--              <el-col :span="6">-->
      <!--                <el-form-item label="可用工时" prop="sumIdleTime" disabled>-->
      <!--                  <el-input v-model="sumData.sumIdleTime" readonly/>-->
      <!--                </el-form-item>-->
      <!--              </el-col>-->
      <!--            </el-row>-->
      <!--            <el-row>-->
      <!--              <el-col :span="12">-->
      <!--                <el-form-item label="完成工时" prop="sumFinishTime" disabled>-->
      <!--                  <el-input v-model="sumData.sumFinishTime" readonly/>-->
      <!--                </el-form-item>-->
      <!--              </el-col>-->
      <!--            </el-row>-->
      <!--          </el-form>-->
      <!--        </div>-->
      <!--        <el-divider/>-->
      <!--        <Table-->
      <!--            :data="tableData4"-->
      <!--            :columns="columns4"-->
      <!--            module="basic"-->
      <!--            stripe-->
      <!--            border>-->
      <!--          <template slot="percent" slot-scope="{ row }">-->
      <!--            <Progress :percent="parseFloat((row.percent * 100).toFixed(2))" :stroke-width="20"/>-->
      <!--          </template>-->
      <!--        </Table>-->
      <!--      </el-tab-pane>-->
      <el-tab-pane label="总计划" name="five">
        <div class="searchBox">
          <el-form :inline="true" :model="filter5">
            <el-form-item label="关键字">
              <el-input v-model="keyword5"/>
            </el-form-item>
            <el-form-item label="计划日期">
              <el-date-picker
                  v-model="planDate5"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  @change="selectPlanDate5"/>
            </el-form-item>
          </el-form>
          <el-button style="height: 29px" :loading="searchLoading5" type="primary" @click="loadData5()">查询</el-button>
          <el-button style="height: 29px" type="primary" plain @click="resetHandle5">重置</el-button>
        </div>
        <div>
          <Table
              :data="tableSum1"
              :columns="columnSum1"
              module="basic"
              stripe
              border/>
        </div>
        <divider/>
        <div style="display: flex;">
          <div>
            <table border style="table-layout:fixed;" module="basic" stripe>
              <tr style="height: 125px;">
                <th>下单日期</th>
                <th>产品代码</th>
                <th>客户名称</th>
                <th>产品名称</th>
                <th>规格型号</th>
                <th>数量</th>
                <th>交期</th>
                <th>业务</th>
              </tr>
              <tr v-for="(item, index) in tableData5" :key="index" :v-if="item.visible">
                <td style="width: 130px;height: 43.5px;">
                  <span
                      :style="{color: item.status>=80 ? 'green' : item.status===30?'orange':item.status===40?'red':'black'}">
                    {{item.orderDate}}</span>
                </td>
                <td style="width: 150px;">
                  <span
                      :style="{color: item.status>=80 ? 'green' : item.status===30?'orange':item.status===40?'red':'black'}">
                    {{item.materialNo}}</span>
                </td>
                <td style="width: 235px;">
                  <span
                      :style="{color: item.status>=80 ? 'green' : item.status===30?'orange':item.status===40?'red':'black'}">
                    {{item.customerName}}</span>
                </td>
                <td>
                  <span
                      :style="{color: item.status>=80 ? 'green' : item.status===30?'orange':item.status===40?'red':'black'}">
                    {{item.materialName}}</span>
                </td>
                <td>
                  <span
                      :style="{color: item.status>=80 ? 'green' : item.status===30?'orange':item.status===40?'red':'black'}">
                    {{item.specification}}</span>
                </td>
                <td>
                  <span
                      :style="{color: item.status>=80 ? 'green' : item.status===30?'orange':item.status===40?'red':'black'}">
                    {{item.quantity}}</span>
                </td>
                <td>
                  <span
                      :style="{color: item.status>=80 ? 'green' : item.status===30?'orange':item.status===40?'red':'black'}">
                    {{item.deliveryDate}}</span>
                </td>
                <td>
                  <span
                      :style="{color: item.status>=80 ? 'green' : item.status===30?'orange':item.status===40?'red':'black'}">
                    {{item.orderName}}</span>
                </td>
              </tr>
            </table>
          </div>
          <div style="width: 25%;float: right; overflow-x:auto;">
            <table border style="table-layout:fixed;width: 1000px;">
              <tr style="height: 20px;">
                <td v-for="(item,date) in productDatePlanVOS" :key="date" style="text-align: center;width:240px;">
                  {{date}}
                </td>
              </tr>
              <tr>
                <td v-for="(item,date) in productDatePlanVOS" :key="date">
                  <table border>
                    <tr style="height: 100px;">
                      <th style="width:60px;word-break: break-all;">绕制(合计)标准工时</th>
                      <th style="width:60px;word-break: break-all;">绕制(合计)可用工时</th>
                      <th style="width:60px;word-break: break-all;">装配(合计)标准工时</th>
                      <th style="width:60px;word-break: break-all;">装配(合计)可用工时</th>
                    </tr>
                    <tr v-for="(model, index) in item" :key="index" :v-if="model.visible">
                      <td style="height: 43.5px;">{{model.raozhiStandardTime}}</td>
                      <td>{{model.raozhiIdleTime}}</td>
                      <td>{{model.zhuangpeiStandardTime}}</td>
                      <td>{{model.zhuangpeiIdleTime}}</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="工位人员计划" name="seven">
        <div class="searchBox">
          <el-form :inline="true" :model="filter7">
            <el-form-item label="关键字">
              <el-input v-model="keyword7"/>
            </el-form-item>
            <el-form-item label="计划日期">
              <el-date-picker
                  v-model="planDate7"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  @change="selectPlanDate7"/>
            </el-form-item>
          </el-form>
          <el-button style="height: 29px" :loading="searchLoading7" type="primary" @click="loadData7()">查询</el-button>
          <el-button style="height: 29px" type="primary" plain @click="resetHandle7">重置</el-button>
        </div>
        <div>
          <Table
              :data="tableSum2"
              :columns="columnSum2"
              module="basic"
              stripe
              border/>
        </div>
        <divider/>
        <div style="display: flex;">
          <div>
            <table border style="table-layout:fixed;">
              <tr style="height: 125px;">
                <th>下单日期</th>
                <th>产品代码</th>
                <th>客户名称</th>
                <th>产品名称</th>
                <th>规格型号</th>
                <th>数量</th>
                <th>交期</th>
                <th>业务</th>
              </tr>
              <tr v-for="(item, index) in tableData7" :key="index" :v-if="item.visible">
                <td style="width: 130px;height: 43.5px;">
                  <span
                      :style="{color: item.status>=80 ? 'green' : item.status===30?'orange':item.status===40?'red':'black'}">
                    {{item.orderDate}}</span>
                </td>
                <td style="width: 150px;">
                  <span
                      :style="{color: item.status>=80 ? 'green' : item.status===30?'orange':item.status===40?'red':'black'}">
                    {{item.materialNo}}</span>
                </td>
                <td style="width: 235px;">
                  <span
                      :style="{color: item.status>=80 ? 'green' : item.status===30?'orange':item.status===40?'red':'black'}">
                    {{item.customerName}}</span>
                </td>
                <td>
                  <span
                      :style="{color: item.status>=80 ? 'green' : item.status===30?'orange':item.status===40?'red':'black'}">
                    {{item.materialName}}</span>
                </td>
                <td>
                  <span
                      :style="{color: item.status>=80 ? 'green' : item.status===30?'orange':item.status===40?'red':'black'}">
                    {{item.specification}}</span>
                </td>
                <td>
                  <span
                      :style="{color: item.status>=80 ? 'green' : item.status===30?'orange':item.status===40?'red':'black'}">
                    {{item.quantity}}</span>
                </td>
                <td>
                  <span
                      :style="{color: item.status>=80 ? 'green' : item.status===30?'orange':item.status===40?'red':'black'}">
                    {{item.deliveryDate}}</span>
                </td>
                <td>
                  <span
                      :style="{color: item.status>=80 ? 'green' : item.status===30?'orange':item.status===40?'red':'black'}">
                    {{item.orderName}}</span>
                </td>
              </tr>
            </table>
          </div>
          <div style="width: 25%;float: right; overflow-x:auto;width: 500px;">
            <table border style="table-layout:fixed;width: 3000px;">
              <tr style="height: 20px;">
                <td v-for="(item,date) in productDatePlanVOS" :key="date" style="text-align: center;width:240px;">
                  {{date}}
                </td>
              </tr>
              <tr>
                <td v-for="(item,date) in productDatePlanVOS" :key="date">
                  <table border>
                    <tr style="height: 100px;">
                      <th style="width:100px;word-break: break-all;">产线机位</th>
                      <th style="width:60px;word-break: break-all;">绕制标准工时</th>
                      <th style="width:60px;word-break: break-all;">绕制可用工时</th>
                      <th style="width:100px;word-break: break-all;">产线机位</th>
                      <th style="width:60px;word-break: break-all;">装配标准工时</th>
                      <th style="width:60px;word-break: break-all;">装配可用工时</th>
                    </tr>
                    <tr v-for="(model, index) in item" :key="index" :v-if="model.visible">
                      <td style="height: 43.5px;">{{model.raozhiWorkUnitName}}</td>
                      <td>{{model.raozhiStandardTime}}</td>
                      <td>{{model.raozhiIdleTime}}</td>
                      <td>{{model.zhaungpeiWorkUnitName}}</td>
                      <td>{{model.zhuangpeiStandardTime}}</td>
                      <td>{{model.zhuangpeiIdleTime}}</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="产能表" name="six">
        <div class="searchBox">
          <el-form :inline="true" :model="filter6">
            <el-form-item label="计划日期">
              <el-date-picker
                  v-model="planDate6"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  @change="selectPlanDate6"/>
            </el-form-item>
          </el-form>
          <el-button style="height: 29px" :loading="searchLoading6" type="primary" @click="loadData6()">查询</el-button>
          <el-button style="height: 29px" type="primary" plain @click="resetHandle6">重置</el-button>
        </div>
        <Table
            :data="tableData6"
            :columns="columns6"
            module="basic"
            stripe
            border/>
      </el-tab-pane>
      <el-tab-pane label="可用工时" name="eight">
        <div class="searchBox">
          <el-form :inline="true" :model="filter8">
            <el-form-item label="计划日期">
              <el-date-picker
                  v-model="planDate8"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  @change="selectPlanDate8"/>
            </el-form-item>
          </el-form>
          <el-button style="height: 29px" :loading="searchLoading8" type="primary" @click="loadData8()">查询</el-button>
          <el-button style="height: 29px" type="primary" plain @click="resetHandle8">重置</el-button>
        </div>
        <div style="display: flex;">
          <div>
            <table border style="table-layout:fixed;">
              <tr style="height: 125px;">
                <th>产线</th>
              </tr>
              <tr v-for="(item, index) in tableData8" :key="index">
                <td style="width: 130px;height: 43.5px;">
                  {{item.centerName}}
                </td>
              </tr>
            </table>
          </div>
          <div style="width: 25%;float: right; overflow-x:auto;width: 1500px;">
            <table border style="table-layout:fixed;width: 800px;">
              <tr style="height: 20px;">
                <td v-for="(item,date) in productDatePlanVOS" :key="date" style="text-align: center;width:120px;">
                  {{date}}
                </td>
              </tr>
              <tr>
                <td v-for="(item,date) in productDatePlanVOS" :key="date">
                  <table border>
                    <tr style="height: 100px;">
                      <th style="width:60px;word-break: break-all;">绕制可用工时</th>
                      <th style="width:60px;word-break: break-all;">装配可用工时</th>
                    </tr>
                    <tr v-for="(model, index) in item" :key="index">
                      <td style="height: 43.5px;">{{model.raozhiIdleTime}}</td>
                      <td>{{model.zhuangpeiIdleTime}}</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <material-stock-preview ref="stockPreview" @save-success="loadData"/>
    <task-bill-preview ref="taskBillPreview"/>
  </div>
</template>

<script>
  import MaterialStockPreview from "@/views/ProductionManagement/ProductionProject/MaterialStockPreview";
  import TaskBillPreview from "@/views/ProductionManagement/ProductionProject/TaskBillPreview";

  export default {
    name: "ProductionProjectList",
    components: {MaterialStockPreview, TaskBillPreview},
    data() {
      return {
        searchLoading: false,
        searchLoading2: false,
        searchLoading3: false,
        searchLoading5: false,
        searchLoading6: false,
        searchLoading7: false,
        searchLoading8: false,
        activateName: "first",
        selectDate: "",
        tableData: [],
        tableData2: [],
        tableData3: [],
        tableData4: [],
        tableData5: [],
        tableData6: [],
        tableData7: [],
        tableData8: [],
        tableSum1: [],
        tableSum2: [],
        productDatePlanVOS: [],
        planDate: [],
        planDate3: [],
        planDate5: [],
        planDate6: [],
        planDate7: [],
        planDate8: [],
        sumData: {
          sumFinishTime: 0,
          sumIdleTime: 0,
          sumWorkTime: 0,
          sumStandardTime: 0,
          sumQuantity: 0,
        },
        pickerOptions: {
          onPick: ({minDate}) => {
            this.selectDate = minDate.getTime();
          },
          disabledDate: time => {
            return this.dealDisabledDate(time);
          },
        },
        filter: {
          date: this.$moment().format("YYYY-MM-DD"),
        },
        filter2: {
          bDate: "",
          eDate: "",
        },
        filter3: {
          bDate: "",
          eDate: "",
        },
        filter5: {
          bDate: "",
          eDate: "",
        },
        keyword5: "",
        filter6: {
          bDate: "",
          eDate: "",
        },
        keyword7: "",
        filter7: {
          bDate: "",
          eDate: "",
        },
        filter8: {
          bDate: "",
          eDate: "",
        },
        columnSum1: [
          {
            title: "",
            key: "processName",
          },
          {
            title: "人员数",
            key: "workerCount",
          },
          {
            title: "标准工时",
            key: "standardTime",
          },
          {
            title: "出勤工时",
            key: "workTime",
          },
          {
            title: "可用工时",
            key: "idleTime",
          },
        ],
        columnSum2: [
          {
            title: "",
            key: "processName",
          },
          {
            title: "人员数",
            key: "workerCount",
          },
          {
            title: "标准工时",
            key: "standardTime",
          },
          {
            title: "出勤工时",
            key: "workTime",
          },
          {
            title: "可用工时",
            key: "idleTime",
          },
        ],
        columns: [
          {
            type: "expand",
            width: 55,
            render: (h, params) => {
              return h("Table", {
                props: {
                  data: params.row.taskDispatchBillVOS,
                  columns: [
                    {
                      title: "工单",
                      key: "billNo",
                      width: 130,
                    },
                    {
                      title: "客户名称",
                      key: "customerName",
                      minWidth: 220,
                    },
                    {
                      title: "规格型号",
                      key: "specification",
                      minWidth: 300,
                    },
                    {
                      title: "标准工时",
                      key: "workTime",
                      width: 100,
                    },
                    {
                      title: "实际工时",
                      key: "actualWorkTime",
                      width: 100,
                    },
                    {
                      title: "数量",
                      key: "quantity",
                      width: 80,
                    },
                    {
                      title: "开工时间",
                      key: "startTime",
                      width: 180,
                    },
                    {
                      title: "交期",
                      key: "deliveryDate",
                      width: 120,
                    },
                  ],
                  border: true,
                  stripe: true,
                },
              });
            },
          },
          {
            title: "产线",
            key: "workCenterName",
          },
          {
            title: "人员",
            key: "scannerName",
          },
          {
            title: "产品标准总工时",
            key: "standardWorkTime",
          },
          {
            title: "实际总工时",
            key: "scanWorkTime",
            render: (h, params) => {
              return h("span", params.row.scanWorkTime.toFixed(2));
            },
          },
          {
            title: "出勤工时",
            key: "scannerWorkTime",
          },
          {
            title: "产线饱和度",
            slot: "percent",
            align: "center",
            width: 300,
          },
        ],
        columns2: [
          {
            type: "expand",
            width: 55,
            render: (h, params) => {
              return h("Table", {
                props: {
                  data: params.row.taskDispatchBillVOS,
                  columns: [
                    {
                      title: "下单时间",
                      key: "orderDate",
                      width: 160,
                    },
                    {
                      title: "物料编号",
                      key: "materialNo",
                      width: 160,
                    },
                    {
                      title: "客户名称",
                      key: "customerName",
                      width: 140,
                    },
                    {
                      title: "物料名称",
                      key: "materialName",
                      width: 140,
                    },
                    {
                      title: "规格型号",
                      key: "specification",
                      width: 160,
                    },
                    {
                      title: "派工单号",
                      key: "billNo",
                      width: 140,
                    },
                    {
                      title: "到料状态",
                      key: "inStockStatus",
                      width: 100,
                      align: "center",
                      render: (h, params) => {
                        return h(
                          "span",
                          {
                            style: {
                              color: "#2d8cf0",
                              cursor: "pointer",
                            },
                            on: {
                              click: () => {
                                if (params.row.purchaseOrderDetailVOS) {
                                  this.$refs.stockPreview.open(params.row.purchaseOrderDetailVOS);
                                }
                              },
                            },
                          },
                          params.row.inStockStatus,
                        );
                      },
                    },
                    {
                      title: "数量",
                      key: "quantity",
                      width: 100,
                    },
                    {
                      title: "交货日期",
                      key: "deliveryDate",
                      width: 150,
                    },
                    {
                      title: "计划工时",
                      key: "workTime",
                      width: 150,
                    },
                  ],
                  border: true,
                  stripe: true,
                },
              });
            },
          },
          {
            title: "产线",
            key: "workCenterName",
          },
          {
            title: "标准工时",
            key: "standardWorkTime",
          },
          {
            title: "计划总工时",
            key: "planWorkTime",
          },
          {
            title: "产线饱和度",
            slot: "percent",
            align: "center",
            width: 300,
          },
        ],
        columns3: [
          {
            type: "expand",
            width: 55,
            render: (h, params) => {
              return h("Table", {
                props: {
                  data: params.row.planEmployeeVOS,
                  columns: [
                    {
                      title: "排产日期",
                      key: "workDate",
                      width: 160,
                    },
                    {
                      title: "排产工时",
                      key: "planWorkTime",
                      width: 160,
                    },
                    {
                      title: "出勤时间",
                      width: 160,
                      key: "standardWorkTime",
                    },
                    {
                      title: "排产工单",
                      key: "planState",
                      width: 100,
                      align: "center",
                      render: (h, params) => {
                        return h(
                          "span",
                          {
                            style: {
                              color: "#2d8cf0",
                              cursor: "pointer",
                            },
                            on: {
                              click: () => {
                                if (params.row.taskDispatchBillVOS) {
                                  this.$refs.taskBillPreview.open(params.row.taskDispatchBillVOS, true);
                                }
                              },
                            },
                          },
                          params.row.planState,
                        );
                      },
                    },
                  ],
                  border: true,
                  stripe: true,
                },
              });
            },
          },
          {
            title: "操作员",
            key: "scannerName",
          },
          {
            title: "工位",
            key: "workCenterName",
          },
          // {
          //   title:"计划总工时",
          //   key:"planWorkTime",
          // },
          // {
          //   title:"产线饱和度",
          //   slot:"percent",
          //   align:"center",
          //   width:300,
          // },
        ],
        columns4: [
          {
            title: "工位",
            key: "workUnitName",
            width: 160,
          },
          {
            title: "客户",
            key: "customerName",
          },
          {
            title: "物料编号",
            key: "materialNo",
          },
          {
            title: "物料描述",
            key: "materialName",
          },
          {
            title: "规格型号",
            key: "specification",
          },
          {
            title: "数量",
            key: "quantity",
            width: 80,
          },
          {
            title: "交期",
            key: "deliveryDate",
          },
          {
            title: "标准工时",
            key: "processStandardTime",
          },
          {
            title: "可用工时",
            key: "idleTime",
          },
          {
            title: "完工工时",
            key: "scanWorkTime",
            render: (h, params) => {
              return h("span", params.row.scanWorkTime.toFixed(2));
            },
          },
          {
            title: "合计",
            key: "scannerWorkTime",
            width: 160,
          },
        ],
        columns5: [
          {
            title: "客户名称",
            key: "customerName",
            width: 160,
          },
          {
            title: "产品名称",
            key: "materialName",
            width: 220,
          },
          {
            title: "规格型号",
            key: "specification",
            width: 220,
          },
          {
            title: "数量",
            key: "quantity",
            width: 80,
          },
          {
            title: "交期",
            key: "deliveryDate",
            width: 100,
          },
          {
            title: "业务",
            key: "orderName",
            width: 100,
          },
        ],
        columns6: [
          {
            title: "产线机位",
            key: "workUnitName",
          },
          {
            title: "标准工时",
            key: "standardTime",
          },
          {
            title: "出勤工时",
            key: "workTime",
          },
          {
            title: "可用工时",
            key: "idleTime",
          },
          {
            title: "实际完工工时",
            key: "actualWorkTime",
          },
        ],
        columns7: [
          {
            title: "客户名称",
            key: "customerName",
            width: 160,
          },
          {
            title: "产品名称",
            key: "materialName",
            width: 220,
          },
          {
            title: "规格型号",
            key: "specification",
            width: 220,
          },
          {
            title: "数量",
            key: "quantity",
            width: 80,
          },
          {
            title: "交期",
            key: "deliveryDate",
            width: 100,
          },
          {
            title: "业务",
            key: "orderName",
            width: 100,
          },
        ],
      };
    },
    mounted() {
      this.loadData();
    },
    methods: {
      loadData() {
        this.searchLoading = true;
        this.$http.get("basic", `taskDispatchPlan/task/${this.filter.date}`).then(res => {
          if (res.success) {
            this.tableData = res.data;
          }
          this.searchLoading = false;
        }).catch(() => {
          this.searchLoading = false;
        });
      },

      loadData2() {
        if (this.filter2.bDate === "" || this.filter2.eDate === "") {
          this.$message.error("计划日期不可为空");
          return;
        }
        this.searchLoading2 = true;
        this.$http.get("basic", `taskDispatchPlan/sche/${this.filter2.bDate}/${this.filter2.eDate}`).then(res => {
          if (res.success) {
            this.tableData2 = res.data;
          }
          this.searchLoading2 = false;
        }).catch(() => {
          this.searchLoading2 = false;
        });
      },

      loadData3() {
        if (this.filter3.bDate === "" || this.filter3.eDate === "") {
          this.$message.error("计划日期不可为空");
          return;
        }
        this.searchLoading3 = true;
        this.$http.get("basic", `taskDispatchPlan/emp/${this.filter3.bDate}/${this.filter3.eDate}`).then(res => {
          if (res.success) {
            this.tableData3 = res.data;
          }
          this.searchLoading3 = false;
        }).catch(() => {
          this.searchLoading3 = false;
        });
      },

      loadData4() {
        this.searchLoading = true;
        this.$http.get("basic", `taskDispatchPlan/machine/${this.filter.date}`).then(res => {
          if (res.success) {
            console.log(res.data);
            this.sumData = res.data;
            this.tableData4 = res.data.unitVOS;
          }
          this.searchLoading = false;
        }).catch(() => {
          this.searchLoading = false;
        });
      },

      loadData5() {
        // this.filter5.bDate = "2023-10-25";
        // this.filter5.eDate = "2023-10-29";
        if (this.filter5.bDate === "" || this.filter5.eDate === "") {
          this.$message.error("计划日期不可为空");
          return;
        }
        this.searchLoading5 = true;
        const params = {
          bDate: this.filter5.bDate,
          eDate: this.filter5.eDate,
          keyWord: this.keyword5,
        };

        this.$http.post("basic", "taskDispatchPlan/allPlan", params).then(res => {
          if (res.success) {
            this.tableData5 = res.data.productPlanVOS;
            this.productDatePlanVOS = res.data.productDatePlanVOS;
            this.tableSum1 = res.data.allProcesses;
          }
          this.searchLoading5 = false;
        }).catch(() => {
          this.searchLoading5 = false;
        });
      },

      loadData6() {
        if (this.filter6.bDate === "" || this.filter6.eDate === "") {
          this.$message.error("计划日期不可为空");
          return;
        }
        this.searchLoading6 = true;
        this.$http.get("basic", `taskDispatchPlan/workUnitPlan/${this.filter6.bDate}/${this.filter6.eDate}`).then(res => {
          if (res.success) {
            this.tableData6 = res.data.workUnitPlans;
          }
          this.searchLoading6 = false;
        }).catch(() => {
          this.searchLoading6 = false;
        });
      },

      loadData7() {
        if (this.filter7.bDate === "" || this.filter7.eDate === "") {
          this.$message.error("计划日期不可为空");
          return;
        }
        const params = {
          bDate: this.filter7.bDate,
          eDate: this.filter7.eDate,
          keyWord: this.keyword7,
        };
        this.searchLoading7 = true;
        this.$http.post("basic", "taskDispatchPlan/empPlan", params).then(res => {
          if (res.success) {
            this.tableData7 = res.data.productPlanVOS;
            this.productDatePlanVOS = res.data.productDatePlanVOS;
            this.tableSum2 = res.data.allProcesses;
          }
          this.searchLoading7 = false;
        }).catch(() => {
          this.searchLoading7 = false;
        });
      },

      loadData8() {
        if (this.filter8.bDate === "" || this.filter8.eDate === "") {
          this.$message.error("计划日期不可为空");
          return;
        }

        this.searchLoading8 = true;
        this.$http.get("basic", `taskDispatchPlan/empIdleTims/${this.filter8.bDate}/${this.filter8.eDate}`).then(res => {
          if (res.success) {
            console.log(res.data);
            this.tableData8 = res.data.productPlanVOS;
            this.productDatePlanVOS = res.data.productDatePlanVOS;
          }
          this.searchLoading8 = false;
        }).catch(() => {
          this.searchLoading8 = false;
        });
      },

      selectPlanDate(value) {
        if (value) {
          this.filter2.bDate = value[0];
          this.filter2.eDate = value[1];
        } else {
          this.filter2.bDate = "";
          this.filter2.eDate = "";
          this.selectDate = "";
        }
      },

      selectPlanDate3(value) {
        if (value) {
          this.filter3.bDate = value[0];
          this.filter3.eDate = value[1];
        } else {
          this.filter3.bDate = "";
          this.filter3.eDate = "";
          this.selectDate = "";
        }
      },

      selectPlanDate5(value) {
        if (value) {
          this.filter5.bDate = value[0];
          this.filter5.eDate = value[1];
        } else {
          this.filter5.bDate = "";
          this.filter5.eDate = "";
          this.selectDate = "";
        }
      },

      selectPlanDate6(value) {
        if (value) {
          this.filter6.bDate = value[0];
          this.filter6.eDate = value[1];
        } else {
          this.filter6.bDate = "";
          this.filter6.eDate = "";
          this.selectDate = "";
        }
      },

      selectPlanDate7(value) {
        if (value) {
          this.filter7.bDate = value[0];
          this.filter7.eDate = value[1];
        } else {
          this.filter7.bDate = "";
          this.filter7.eDate = "";
          this.selectDate = "";
        }
      },

      selectPlanDate8(value) {
        if (value) {
          this.filter8.bDate = value[0];
          this.filter8.eDate = value[1];
        } else {
          this.filter8.bDate = "";
          this.filter8.eDate = "";
          this.selectDate = "";
        }
      },

      resetHandle() {
        this.filter.date = "";
      },

      resetHandle2() {
        this.filter2.bDate = "";
        this.filter2.eDate = "";
        this.selectDate = "";
        this.planDate = [];
      },

      resetHandle3() {
        this.filter3.bDate = "";
        this.filter3.eDate = "";
        this.selectDate = "";
        this.planDate3 = [];
      },
      resetHandle5() {
        this.filter5.bDate = "";
        this.filter5.eDate = "";
        this.keyword5 = "";
        this.selectDate = "";
        this.planDate5 = [];
      },
      resetHandle6() {
        this.filter6.bDate = "";
        this.filter6.eDate = "";
        this.selectDate = "";
        this.planDate6 = [];
      },
      resetHandle7() {
        this.filter7.bDate = "";
        this.filter7.eDate = "";
        this.keyword7 = "";
        this.selectDate = "";
        this.planDate7 = [];
      },
      resetHandle8() {
        this.filter8.bDate = "";
        this.filter8.eDate = "";
        this.selectDate = "";
        this.planDate8 = [];
      },
      dealDisabledDate(time) {
        if (this.selectDate !== "") {
          return (
            time.getTime() > this.selectDate + 14 * 24 * 60 * 60 * 1000 || time.getTime() < this.selectDate
          );
        }
      },


    },
  };
</script>

<style lang="scss" scoped>
.searchBox {
  display: flex;
  background-color: #f4f7fa;
  padding: 10px 10px 5px 10px;
  border: 1px solid #e8e8e8;
  border-radius: 3px;
  margin-bottom: 5px;

  .el-form-item {
    margin-bottom: 5px;
  }

  .el-input__inner {
    width: 180px;
  }

  .el-date-editor {
    width: 360px;
  }
}

.table-left {
  width: 100%;
  //border-top: 1px solid #dddddd;
  //border-left: 1px solid #dddddd;
  border: 1px;

  tr {
    //display: block;

    td {
      //display: inline-block;
      font-size: 15px;
      text-align: center;
      border: 1px;
      //border-right: 1px solid #dddddd;
      //border-bottom: 1px solid #dddddd;
      //padding: 10px 0;
      font-weight: bold;
      width: 120px;
    }
  }
}

.table-right {
  //border-top: 1px solid #dddddd;
  //border-left: 0;
  border: 1px;
  overflow: hidden;

  tr {
    //display: block;
    white-space: nowrap;

    td {
      //display: inline-block;
      font-size: 15px;
      text-align: center;
      border: 1px;
      //border-right: 1px solid #dddddd;
      //border-bottom: 1px solid #dddddd;
      //padding: 10px 0;
      //width: 110px;
    }
  }
}
</style>